var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('doc.status_code_title')))]),_c('div',{staticClass:"table"},[_c('el-table',{attrs:{"data":_vm.tableData,"header-cell-style":{
      backgroundColor: '#0077FF',
      color: '#FFF',
      fontWeight: '500'
    }}},[_c('el-table-column',{attrs:{"prop":"code","label":_vm.$t('doc.col_code'),"width":"400"}}),_c('el-table-column',{attrs:{"prop":"tips","label":_vm.$t('doc.col_tips')}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }